import { Component } from 'react'
import s from './NameCellRenderer.scss'
import { Link } from 'react-router-dom'

class NameCellRenderer extends Component {
  render() {
    const { data, path } = this.props
    if (!data) return null
    const { id, name } = data

    return (
      <Link className={s.link} to={`/${path}/${id}`}>
        {name}
      </Link>
    )
  }
}

export default NameCellRenderer
